import React from "react";

import { Title } from "Cobalt/Header";
import { StandaloneTrigger, Modal, ModalBody, ModalHeader, ModalFooter } from "Cobalt/Modal";
import Button from "Common/Button";

import LifeCostBreakdownBody from "./LifeCostBreakdownBody";

import type { LifePlan } from "Utils/types";

type Props = {
  plan: LifePlan;
  triggerText: React.ReactNode;
  triggerClassName?: string;
  footer?: (arg0: () => void) => React.ReactNode;
  trackOpen?: () => void;
  startEnabled?: boolean;
};

const LifeCostBreakdownModal = ({ plan, triggerText, headerText, triggerClassName, footer, trackOpen, startEnabled }: Props) => (
  <StandaloneTrigger
    startEnabled={startEnabled}
    trigger={(props) => (
      <a
        className={triggerClassName}
        href="#"
        {...props}
        onClick={(e) => {
          props.onClick(e);
          if (trackOpen) trackOpen();
        }}
      >
        {triggerText}
      </a>
    )}
    modal={(props) => (
      <Modal className="LifePriceBreakdown" {...props}>
        <ModalHeader closeButton>
          <Title mb={2}>{headerText || "Cost Breakdown"}</Title>
        </ModalHeader>
        <ModalBody>
          <LifeCostBreakdownBody plan={plan} />
        </ModalBody>
        <ModalFooter>
          {footer ? (
            footer(props.onHide)
          ) : (
            <Button key="close" onClick={() => props.onHide()}>
              Close
            </Button>
          )}
        </ModalFooter>
      </Modal>
    )}
  />
);

export default LifeCostBreakdownModal;
